"use strict";
/**
 * imports
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TickContext = void 0;
// external
const React = require("react");
/**
 * tick context
 *
 * @type {React.Context<ITickContextProvider>}
 */
exports.TickContext = React.createContext({
    tick: undefined
});
//# sourceMappingURL=index.js.map